import { Box, BoxProps, ColorOptions, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { NavigationContainer, NavigationIndependentTree } from '@react-navigation/native'
import { useState } from 'react'
import Footer from '../../comps/Footer'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { helpCenterData } from '../../static/staticData'
import { staticStrings } from '../../static/staticStrings'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import { Accordion } from './Accordion'
import { EmailUs } from './EmailUs'
import { TabBar } from './TabBar'

const HelpCenter = ({ route }) => {
  const type = route?.params?.type
  const [navVisible, setNavVisible] = useState(false)
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }
  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }

  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  const resPadding = usePadding()
  const { subHeaderSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)
  const Tab = createMaterialTopTabNavigator()
  return (
    <>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar isBg={true} onPress={handleNav} hamBurgerType="primary" />
      <Box f={1} bg={'WHITE'}>
        <Box
          flexDirection={'row'}
          align={'center'}
          justify={'space-between'}
          pv={isMobile ? 16 : 24}
          ph={resPadding}
          maxHeight={isMobile ? undefined : 80}
          borderBottomWidth={isMobile ? 0 : 1}
          borderBottomColor={'DISABLED_GREY'}>
          <Text title={'Help Centre'} fontSize={subHeaderSize} fontFamily={'jiotype-black'} />
          {!isMobile && (
            <Box flexDirection={'row'} align={'center'}>
              <EmailUs />
            </Box>
          )}
        </Box>
        <Spacer size={isMobile ? 0 : 32} />
        <Box ph={resPadding}>
          <Text title={staticStrings.frequentlyAsked} fontSize={isMobile ? 16 : 18} fontFamily={'jiotype-medium'} />
        </Box>
        <Spacer size={isMobile ? 20 : 24} />
        <Box>
          <NavigationIndependentTree>
            <NavigationContainer>
              <Tab.Navigator
                initialRouteName={type ? type : undefined}
                offscreenPageLimit={2}
                tabBar={TabBar}
                screenOptions={{
                  sceneStyle: {
                    paddingVertical: isMobile ? 16 : 32,
                    backgroundColor: 'white',
                    paddingHorizontal: resPadding,
                  },
                }}>
                <>
                  {Object.keys(helpCenterData).map((key, index) => (
                    <Tab.Screen name={key} key={index.toString()} component={AccordionComp(key)} />
                  ))}
                </>
              </Tab.Navigator>
            </NavigationContainer>
          </NavigationIndependentTree>
        </Box>

        {isMobile && (
          <Box position={'sticky'} bottom={0} bg={'#0070B618' as ColorOptions} h={86} justify={'center'}>
            <EmailUs />
          </Box>
        )}
        <Box {...styles.footerBackground(isMobile)}>
          <Footer />
        </Box>
      </Box>
    </>
  )
}

const AccordionComp = (key) => () => <Accordion type={key} />

const styles = {
  footerBackground: (isMobile: boolean) =>
    ({
      boxShadow: '0px 4px 4px #00000029' as ColorOptions,
      bg: 'WHITE',
      borderWidth: 1,
      borderColor: 'DISABLED_GREY',
      mt: isMobile ? 0 : 40,
      borderTopLeftRadius: isMobile ? 32 : 80,
      borderTopRightRadius: isMobile ? 32 : 80,
      zIndex: 100,
    } as BoxProps),
}
export default HelpCenter
